import { checkIntlSupportedCurrencyPolyfill } from './polyfill'

let supportedCurrencies: Set<string> | undefined

const isSupportedCurrency = (currency?: string) => {
  if (!currency) {
    return false
  }

  const currencyKey = currency.toUpperCase()

  if (!supportedCurrencies) {
    supportedCurrencies = new Set([...(Intl as any).supportedValuesOf('currency')])
  }

  const isSupported = supportedCurrencies.has(currencyKey)
  return isSupported
}

export const checkIntlSupportedCurrency = (currency?: string, locale?: string) => {
  if (!currency) {
    return false
  }

  const currencyKey = currency.toUpperCase()

  const intlSupported = typeof (Intl as any).supportedValuesOf !== 'undefined'

  if (intlSupported) {
    return isSupportedCurrency(currencyKey)
  }

  return checkIntlSupportedCurrencyPolyfill(currencyKey, locale)
}
